const groups = {
  1: 'Group 1',
  2: 'Group 1A',
  3: 'Group 2',
  4: 'Not Qualified',
  0: 'Not Qualified',
  "-1": 'Not Qualified',
}

export default groups
